import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';

class Footer extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-main">
            <div className="footer-brand-block">
              <div className="footer-logo">
                <span className="footer-logo-title">JASON'S</span>
                <span className="footer-logo-subtitle">WINE &amp; SPIRITS</span>
              </div>
              <p className="footer-brand-text">
                Downtown LA’s trusted liquor store for over 40 years.
              </p>

              <div className="footer-social-icons">
                <a href="https://www.instagram.com/jasonsliquor/" aria-label="Instagram" className="footer-social-link" target="_blank" rel="noopener noreferrer">IG</a>
                <a href="https://www.facebook.com/jasonsliquor/" aria-label="Facebook" className="footer-social-link" target="_blank" rel="noopener noreferrer">FB</a>
                <a href="https://www.yelp.com/biz/jasons-wine-and-spirits-los-angeles" aria-label="Yelp" className="footer-social-link" target="_blank" rel="noopener noreferrer">Yelp</a>
              </div>
            </div>

            <div className="footer-columns">
              <div className="footer-column">
                <h3 className="footer-heading">Company</h3>
                <Link to="/our-story" className="footer-link">Our Story</Link>
                <Link to="/contact" className="footer-link">Contact Us</Link>
              </div>

              <div className="footer-column">
                <h3 className="footer-heading">Contact</h3>
                <p className="footer-text">
                  (213) 485-9463<br />
                  <a href="mailto:info@jasonsliquor.com" className="footer-link">
                    info@jasonsliquor.com
                  </a><br />
                  828 S. Main Street<br />
                  Los Angeles, CA 90014
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-inner">
            <div className="footer-bottom-left">
              <span className="footer-bottom-brand">JASON'S WINE &amp; SPIRITS</span>
              <span className="footer-bottom-copy">© 2025 All rights reserved</span>
            </div>

            <div className="footer-bottom-links">
              <Link to="/tos" className="footer-bottom-link">Terms</Link>
              <Link to="/privacy-policy" className="footer-bottom-link">Privacy</Link>
              <Link to="/shipping" className="footer-bottom-link">Shipping</Link>
              <Link to="/refunds" className="footer-bottom-link">Refunds</Link>
            </div>
          </div>
        </div>
      </footer>
    )
  }

}

export default connect((state) => {
  return {
    loading: state.getIn(['users', 'loading']),
    error: state.getIn(['users', 'error'])
  };
})(Footer);



// WEBPACK FOOTER //
// ./src/containers/commons/Footer.js